// Services
import { AjaxService } from 'NewAngular/services/core/ajax.service';
import { UrlsService } from 'NewAngular/services/core/urls.service';
import * as i0 from "@angular/core";
import * as i1 from "NewAngular/services/core/ajax.service";
import * as i2 from "NewAngular/services/core/urls.service";
export class IndicatorsService {
    constructor(ajaxService, urlsService) {
        this.ajaxService = ajaxService;
        this.urlsService = urlsService;
    }
    getIndicatorsAllEconomicData() {
        const url = this.urlsService.INDICATORS.INDICATORS_ALL_ECONOMIC_DATA;
        return this.ajaxService.getDataObserveBody(url);
    }
    /**
     * Given some search IDs from the indicators autocompleter, retrieves the fields needed for displaying
     * the indicators as part of a watchlist in the edit indicator watchlist modal.
     * @param searchIds: array of indicator IDs, e.g. ['I:USEHS', 'I:USUR', 'I:VIX']
     * @returns Observable<EditWatchlistModalIndicator[]> with the information for the requested indicators
     */
    getIndicatorsInfoForWatchlist(searchIds) {
        const params = { indicators: searchIds };
        return this.ajaxService.postJsonDataObserveBody(this.urlsService.INDICATORS.INDICATORS_INFO_WATCHLIST, params);
    }
    getIndicatorsGeographiesData(regionType) {
        const urlParams = { regionType };
        const url = this.urlsService.getUrl(this.urlsService.INDICATORS.INDICATOR_GEOGRAPHIES_DATA_VIEW, urlParams);
        return this.ajaxService.getDataObserveBody(url);
    }
}
IndicatorsService.ɵfac = function IndicatorsService_Factory(t) { return new (t || IndicatorsService)(i0.ɵɵinject(i1.AjaxService), i0.ɵɵinject(i2.UrlsService)); };
IndicatorsService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: IndicatorsService, factory: IndicatorsService.ɵfac, providedIn: 'root' });
